import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import GlobalStyles from '@mui/material/GlobalStyles';
import TitleBar, { TITLEBAR_HEIGHT } from './TitleBar';

// Detecta o ambiente Electron pelo flag exposto no preload (electron/preload.ts).
const isDesktop = typeof window !== 'undefined' && window.desktop?.isElectron === true;

// ==============================|| CASCA DESKTOP (TITLEBAR + VIEWPORT) ||============================== //
//
// No navegador, renderiza os filhos sem alteração. No Electron, adiciona a
// barra de título customizada no topo e coloca o app num container rolável,
// para a janela frameless não exibir scroll duplo.

export default function DesktopChrome({ children }: { children: ReactNode }) {
  if (!isDesktop) return <>{children}</>;

  return (
    <>
      <GlobalStyles
        styles={{
          // Offset usado pelo app para descontar a barra de título dos cálculos
          // de altura total (100vh). No navegador a variável não existe e o
          // fallback `var(--tb-offset, 0px)` mantém o comportamento original.
          ':root': { '--tb-offset': `${TITLEBAR_HEIGHT}px` },
          'html, body, #root': { height: '100%' },
          body: { margin: 0, overflow: 'hidden' }
        }}
      />
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <TitleBar />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            position: 'relative'
            // IMPORTANTE: nada de `transform`/`filter`/`perspective`/`will-change`
            // aqui. Qualquer um deles tornaria este container o containing block
            // dos elementos position:fixed (AppBar, Drawer) e eles passariam a
            // rolar JUNTO com o conteúdo (viram `absolute` na prática). Sem isso,
            // o position:fixed se ancora na viewport e fica realmente fixo. O
            // desconto da barra de título é feito com `top: var(--tb-offset)`
            // diretamente nesses elementos (Header, Drawer, Loader).
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}
